import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Paper, Button, Stack, Box, Typography, Tabs, Tab, TextField, } from '@mui/material';
// import { API } from 'aws-amplify'
import Grid from '@mui/material/Grid';
import BobForecastRoutes, { BobForecastRoutesRef } from './BoBForecastRoutes';
import BobForecastPackagePlans, { BobForecastPackagePlansRef } from './BoBForecastPackagePlans';

function BoBForecast() {
    const [tabIndex, setTabIndex] = useState(0);
    const [showCreatePackagePlan, setShowCreatePackagePlan] = useState(false);
    const [showCreateRoute, setShowCreateRoute] = useState(false);
    const { clientCode } = useParams();
    const [searchText, setSearchText] = useState<string | undefined>(undefined);
    const [filterTerm, setFilterTerm] = useState<string | undefined>(undefined);
    const packingPlansGridRef = useRef<BobForecastPackagePlansRef>(null);
    const routesGridRef = useRef<BobForecastRoutesRef>(null);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setFilterTerm(searchText);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [searchText]);

    const handleFilterReset = () => {
        setSearchText('');
        setFilterTerm('');
        packingPlansGridRef.current?.clearFilter();
        routesGridRef.current?.clearFilter();
    };

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };



    return (
        <Grid container spacing={3}>
            {/* <Grid item xs={12}>
                <PageHeader title={t('BoB Forecast')}>
                <Stack direction='row' spacing={2}>
                    <Button variant="contained" onClick={() => setShowCreateDialog(true)}>Create</Button>
                </Stack>
                </PageHeader>
            </Grid> */}
            <Grid item xs={12}>
                <Paper sx={{ p: 2, paddingBottom: 0, display: 'flex', flexWrap: 'wrap', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }} elevation={3}>
                    <Box sx={{ flexGrow: 1, mr: { xs: 0, md: 2 }, mb: { xs: 2, md: 0 } }}>
                        <Typography variant="subtitle1" component="h2" sx={{ textTransform: 'uppercase' }}>
                            BoB Forecast
                        </Typography>

                    </Box>
                    <Box flexGrow={0}>
                        <Stack direction='row' spacing={2}>
                            <Button variant="contained" onClick={() => tabIndex === 0 ? setShowCreatePackagePlan(true) : setShowCreateRoute(true)}>Create</Button>
                            {/* <Button variant="contained">Create</Button> */}
                        </Stack>
                    </Box>
                    <div style={{ flexBasis: '100%', flexGrow: 1 }} />
                    <Tabs value={tabIndex} onChange={handleTabChange}>
                        <Tab label="Packing Plans" />
                        <Tab label="Routes" />
                    </Tabs>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ p: 2 }} elevation={3}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField label="Search" variant="outlined" fullWidth size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                        <Button variant="contained" onClick={handleFilterReset} >
                            Reset
                        </Button>
                    </Box>
                </Paper>
            </Grid>

            {tabIndex === 0 ? <BobForecastPackagePlans open={true} clientCode={clientCode ?? 'BNX'} showCreateDialog={showCreatePackagePlan} cancelAction={() => setShowCreatePackagePlan(false)} createAction={(item) => setShowCreatePackagePlan(false)} filterTerm={filterTerm} ref={packingPlansGridRef} /> : <BobForecastRoutes open={true} clientCode={clientCode ?? 'BNX'} showCreateDialog={showCreateRoute} cancelAction={() => setShowCreateRoute(false)} filterTerm={filterTerm} ref={routesGridRef}/>}
        </Grid>
    );
}

export default BoBForecast;